import { IPassword } from "@interfaces";
import { memo } from "react";
import * as Yup from "yup";
import { useYup } from "@validations";
import { Input, Form, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { SharedButton, StyledAuth } from "@components";
import { logout, selectApp, setLoading, setRefresh, useAppDispatch } from "@redux";

import { useNotify } from "@utils";
import { useHistory, useLocation } from "react-router";
import { PATH_FORGOT_PASSWORD } from "@configs";
import { authApi } from "@api";
import { useSelector } from "react-redux";

const initValue: IPassword = {
  current_password: "",
  new_password: "",
  confirm_password: "",
};

export const CreatePasswordForm = memo(() => {
  const { YupPassword } = useYup();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { success, error } = useNotify();
  const { pathname } = useLocation();
  const { temp } = useSelector(selectApp);
  const history = useHistory();
  // form and validation
  const passwordSchema = Yup.object().shape(YupPassword);
  const [passwordForm] = Form.useForm();

  const onFinish = async (values: IPassword) => {
    try {
      dispatch(setLoading(true));
      await authApi.changePassword(values);
      await dispatch(setRefresh(temp));
      success(t("message.change.success"));
      await dispatch(logout());
      // history.push(PATH_HOME);
    } catch (err: any) {
      error(t("message.change.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const yupSync = {
    async validator({ field }: any, value: any) {
      await passwordSchema.validateSyncAt(field, { [field]: value });
    },
  };
  const isForgot = () => pathname === PATH_FORGOT_PASSWORD;
  return (
    <StyledAuth>
      <header>
        <h4>{isForgot() ? t("page.forgot_password") : t("page.change_password")}</h4>
        <p>{isForgot() ? null : t("page.you_need_to_change_your_password")}</p>
      </header>
      <Form
        form={passwordForm}
        name="basic"
        initialValues={initValue}
        onFinish={onFinish}
        layout="vertical"
      >
        {/* <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={24} md={24} sm={24}>
            <Form.Item label={t("page.current_password")} name="current_password" rules={[yupSync]}>
              <Input.Password type="password" />
            </Form.Item>
          </Col>
        </Row> */}
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={24} md={24} sm={24}>
            <Form.Item label={t("page.new_password")} name="new_password" rules={[yupSync]}>
              <Input.Password type="password" />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={24} md={24} sm={24}>
            <Form.Item label={t("page.confirmPassword")} name="confirm_password" rules={[yupSync]}>
              <Input.Password type="password" />
            </Form.Item>
          </Col>
        </Row> */}
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={8} md={8} sm={8} />
          <Col lg={8} md={8} sm={8}>
            <SharedButton type="primary" htmlType="submit" size="middle">
              {t("page.change_password")}
            </SharedButton>
          </Col>
          <Col lg={8} md={8} sm={8} />
        </Row>
      </Form>
    </StyledAuth>
  );
});
